import { useState } from 'react';
import { uploadLogisticServiceFile } from 'views/LogisticServices/utils/logisticServices.utils';

export const useUploadPaymentVoucherForLogisticService = () => {
  const [isLoading, setIsLoading] = useState(false);

  const uploadFile = async (id: number, file?: File, billingCountryId?: number) => {
    if (!file || !billingCountryId) return;

    return new Promise(resolve => {
      uploadLogisticServiceFile({
        logisticServiceId: id,
        type: 'proofOfPayment',
        file,
        handleLoading: setIsLoading,
        updateDataCallback: () => resolve(true),
        billingCountryId: billingCountryId
      });
    });
  };
  return { uploadFile, isLoading };
};
